import { HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedInobramxMaxMin: null,
    loadedInobramxExternalMaxMin: null
  },
  getters: {
    loadedInobramxMaxMin (state) {
      return state.loadedInobramxMaxMin
    },
    loadedInobramxExternalMaxMin (state) {
      return state.loadedInobramxExternalMaxMin
    }
  },
  mutations: {
    setLoadedInobramxMaxMin (state, payload) {
      state.loadedInobramxMaxMin = payload
    },
    clearLoadedInobramxMaxMin (state) {
      state.loadedInobramxMaxMin = null
    },
    setLoadedInobramxExternalMaxMin (state, payload) {
      state.loadedInobramxExternalMaxMin = payload
    },
    clearLoadedInobramxExternalMaxMin (state) {
      state.loadedInobramxExternalMaxMin = null
    }
  },
  actions: {
    fetchInobramxMaxMin ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('inobramx/maxmin', {
          params: {
            mac: payload.mac || null,
            initial_date: payload.initial_date || null,
            initial_hour: payload.initial_hour || null,
            final_date: payload.final_date || null,
            final_hour: payload.final_hour || null
          }
        })
          .then(result => {
            const uniqueSortedData = Array.from(
              new Map(
                result.data
                  .sort((a, b) => a.age - b.age)
                  .map(item => [item.age, item])
              ).values()
            )
            commit('setLoadedInobramxMaxMin', uniqueSortedData)
            resolve(uniqueSortedData)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    fetchInobramxExternalMaxMin ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('inobramx/maxmin', {
          params: {
            mac: payload.mac || null,
            initial_date: payload.initial_date || null,
            initial_hour: payload.initial_hour || null,
            final_date: payload.final_date || null,
            final_hour: payload.final_hour || null,
            location: 'external'
          }
        })
          .then(result => {
            const uniqueSortedData = Array.from(
              new Map(
                result.data
                  .sort((a, b) => a.age - b.age)
                  .map(item => [item.age, item])
              ).values()
            )
            commit('setLoadedInobramxExternalMaxMin', uniqueSortedData)
            resolve(uniqueSortedData)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    clearLoadedInobramxMaxMin ({ commit }) {
      commit('clearLoadedInobramxMaxMin')
    },
    clearLoadedInobramxExternalMaxMin ({ commit }) {
      commit('clearLoadedInobramxExternalMaxMin')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inobramx_max_min/index.js